import * as React from 'react';
/**
 * @ignore - internal component.
 */

var RadioGroupContext = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

export default RadioGroupContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js
// module id = 347
// module chunks = 0